'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dAd$002dHoc$0024package$0024$002dColor$00241 from "./samples.-Ad-Hoc$package$-Color$1.js";
import * as $j_scala$002eruntime$002e$002dEnum$002dValue from "./scala.runtime.-Enum-Value.js";
var $p;
/** @constructor */
function $c_Lsamples_AdHoc$package$Color$3$$anon$2(Color$lzy1$15, outer) {
  this.sp = null;
  if ((outer === null)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_NullPointerException__(new $j_java$002elang$002e$002dObject.$c_jl_NullPointerException());
  }
  $j_samples$002e$002dAd$002dHoc$0024package$0024$002dColor$00241.$ct_Lsamples_AdHoc$package$Color$1__T__(this, "FFF");
}
export { $c_Lsamples_AdHoc$package$Color$3$$anon$2 as $c_Lsamples_AdHoc$package$Color$3$$anon$2 };
$p = $c_Lsamples_AdHoc$package$Color$3$$anon$2.prototype = new $j_samples$002e$002dAd$002dHoc$0024package$0024$002dColor$00241.$h_Lsamples_AdHoc$package$Color$1();
$p.constructor = $c_Lsamples_AdHoc$package$Color$3$$anon$2;
/** @constructor */
function $h_Lsamples_AdHoc$package$Color$3$$anon$2() {
}
export { $h_Lsamples_AdHoc$package$Color$3$$anon$2 as $h_Lsamples_AdHoc$package$Color$3$$anon$2 };
$h_Lsamples_AdHoc$package$Color$3$$anon$2.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return "White";
});
$p.b = (function() {
  return "White";
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$f_T__hashCode__I("White");
});
$p.y = (function(p) {
  return this;
});
var $d_Lsamples_AdHoc$package$Color$3$$anon$2 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_AdHoc$package$Color$3$$anon$2, "samples.AdHoc$package$Color$3$$anon$2", ({
  oc: 1,
  bw: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Lsamples_AdHoc$package$Color$3$$anon$2 as $d_Lsamples_AdHoc$package$Color$3$$anon$2 };
